import { AdminRole } from "@repo/api-dtos"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import * as React from "react"
import { PageHeader } from "@/components/layout"
import { Skeleton } from "@/components/ui/skeleton"
import { useAdminRolesContext } from "@/contexts/admin-roles-context"
import { DiscordSettingsForm } from "@/features/api-access-config/DiscordSettingsForm"
import { useApiAccessRequestConfig } from "@/queries/marketplace"

export const Route = createFileRoute("/configuration/api-access")({
	component: ApiAccessConfigurationPage,
})

function ApiAccessConfigurationPage() {
	const navigate = useNavigate()
	const { hasRole } = useAdminRolesContext()
	const canRead = hasRole(AdminRole.IntegrationsAdmin)
	const { data: config, isLoading, error } = useApiAccessRequestConfig()

	React.useEffect(() => {
		if (!canRead) navigate({ to: "/unauthorized" })
	}, [canRead, navigate])
	if (!canRead) return null

	return (
		<div className="flex max-w-4xl flex-col gap-6 p-6">
			<PageHeader
				title="API access"
				description="The Discord roles and channel used when an API access request is approved: the API role for every approved applicant, the App Developers role for apps, and the channel for the welcome message."
			/>
			{error ? (
				<div className="rounded-lg bg-bad-soft px-4 py-3 text-bad">
					Failed to load the configuration: {error.message}
				</div>
			) : isLoading || !config ? (
				<Skeleton className="h-[420px] w-full rounded-lg" />
			) : (
				<DiscordSettingsForm config={config} />
			)}
		</div>
	)
}
